import { render } from "./AllTccRemainder.vue?vue&type=template&id=57b1e573&scoped=true"
import script from "./AllTccRemainder.vue?vue&type=script&lang=js"
export * from "./AllTccRemainder.vue?vue&type=script&lang=js"

import "./AllTccRemainder.vue?vue&type=style&index=0&id=57b1e573&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b1e573"]])

export default __exports__